module.exports = __webpack_public_path__ + "static/media/remando-partitura.c8082605.png";